import VideoScrubber from "@components/VideoScrubber";
import PowerMode from "@core/power-mode";
import anime from "animejs";
import { $ } from "@utils/dom";

import { INVIEW_ENTER } from "@scroll/constants";
const VIDEO_FRAMERATE = 1000 / 30;

class PbRowHero {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this._inView = false;
    this._animated = false;
    this._videoReady = false;
    this._animationReady = false;
    this._delayFinished = false;

    this._tweenMedia = { value: 0 };
    this._tweenVideo = { value: 0 };
    this._videoProgress = 0;

    this.video = $('.pb-row-hero__video', this.el);
    this.media = $('.pb-row-hero__media', this.el);
    this.mediaShadow = $('.pb-row-hero__mediaShadow', this.el);

    this._duration = 1100;
    this._delay = getComputedStyle(this.el).getPropertyValue("--module-delay") ? parseFloat(getComputedStyle(this.el).getPropertyValue("--module-delay")) : 20;
    this._initialX = getComputedStyle(this.media).getPropertyValue("--initial-x") ? parseFloat(getComputedStyle(this.media).getPropertyValue("--initial-x")) : -50;

    this._scrollObj = null;

    if( this.video ) {
      this.videoScrub = new VideoScrubber(this.video);
      this._videoTick = null;
    }

    this._onScrollCall = this._onScrollCall.bind(this);
    this._animate = this._animate.bind(this);
    this._onVideoReady = this._onVideoReady.bind(this);
    this._seekVideo = this._seekVideo.bind(this);
  }

  init() {
    this._bindEvents();
    this._onVideoReady();
  }
  destroy() {
    this._unbindEvents();
    if( this._videoTick ) clearInterval(this._videoTick);
    if( this.videoScrub ) this.videoScrub.destroy();

    this.el = null;
    this.emitter = null;

    this._inView = null;
    this._animated = null;
    this._videoReady =  null;
    this._animationReady =  null;
    this._delayFinished =  null;

    this._duration =  null;
    this._delay =  null;
    this._initialX = null;

    this._tweenMedia = null;
    this._scrollObj = null;

    this.video = null;
    this.videoScrub = null;
    this.media = null;

    this._videoTick = null;

    this._onScrollCall = null;
    this._animate = null;
    this._onVideoReady = null;
  }

  _bindEvents() {
    this.emitter.on('SiteScroll.pb-row-hero', this._onScrollCall);
    
    // if(this.video) {
    //   if( PowerMode.low === true ) this._onVideoReady();
    //   else this.video.addEventListener("canplay", this._onVideoReady);
    // }
  }
  _unbindEvents() {
    this.emitter.off('SiteScroll.pb-row-hero', this._onScrollCall);
    // if(this.video) this.video.removeEventListener("canplay", this._onVideoReady);
  }

  _onScrollCall(direction, obj) {
    // if event is not related to this module, stop here
    if (obj.el !== this.el) return;

    // update inView status
    this._inView = direction === INVIEW_ENTER;
    this._scrollObj = obj;

    if(this._inView) {
      setTimeout(() => {
        this._delayFinished = true;
        this._animate();
      }, this._delay);

      if( !this._videoTick ) this._videoTick = setInterval(this._seekVideo, VIDEO_FRAMERATE);
    } else {
        // stop interval if running
        if( this._videoTick ) clearInterval(this._videoTick);
        this._videoTick = null;
      }
  }

  _onVideoReady(){
    this._videoReady = true;
    this._animate();
  }

  _seekVideo() {
    this._videoProgress = (this._scrollObj.progress * .5) + (this._tweenVideo.value * .5);
    this.videoScrub.scrub(this._videoProgress);
  }

  _animate(){
    if (!this.media || this._animated || !this._delayFinished || this.video && !this._videoReady) return;
    this._animated = true;
    this._startAnimation();

    anime({
      targets: this._tweenMedia,
      value: [1, 0],
      delay: 0,
      duration: this._duration,
      easing: 'easeOutCubic',
      update: () => {
        this.media.style.transform = `translateX(${this._tweenMedia.value * this._initialX}vw)`;

        if(this._tweenMedia.value < .3 && this.mediaShadow) {
          const shadowValue = this._tweenMedia.value / .3;
          const shadowOpacity = getComputedStyle(this.mediaShadow).getPropertyValue("--opacity") ? parseFloat(getComputedStyle(this.mediaShadow).getPropertyValue("--opacity")) : .5;

          this.mediaShadow.style.transform = `translateX(${shadowValue * 20}%)`;
          this.mediaShadow.style.opacity = `${(1 - shadowValue) * shadowOpacity}`;
        }
      }
    });

    if (this.video) {
      anime({
        targets: this._tweenVideo,
        value: [0, 1],
        delay: 0,
        duration: this._duration,
        easing: 'linear',
        update: () => {
          this._seekVideo();
        }
      });

    }

  }

  _startAnimation(){
    if (this._animationReady) return;
    this._animationReady = true;

    this.el.classList.add('--js-ready');
  }

}

export default PbRowHero;
